import Form from "../components/Form";
import contactbg from "../media/contactus.png";
import "./Contact.css";

export const Contact = () => {
  return (
    <>
      <section className="contact" id="contact">
        <h2>
          Contact us for any Query!
          <hr />
        </h2>
      
        <div className="row">
          <div className="img">
            <img src={contactbg} id="contactimg" alt={""} />
          </div>
          <Form />
        </div>
      </section>
      <hr id="line" />

      <div className="callbox">
        <i className="fas fa-phone"></i> +91-9415930411, 6394712952
      </div>
      <div className="callbox">
        <i className="fas fa-briefcase"></i> www.sonbhadratourism.com
      </div>
      <div className="callbox">
        <i className="fas fa-envelope"></i> contact@sonbhadratourism.com
      </div>
    </>
  );
};
